import { generateUserAgentHeader, urls } from 'Utilities/dataHelpers';
import mediator from 'Utilities/mediator';

export const verifyEmailOrPhone = async (
  email: string,
  phone: string,
  osType: string,
  osVersion: string,
  app: App,
  appVersion: string,
  deviceId: string,
  force = false
) => {
  const result = await mediator.request<ApiResponse<{ code: number }>>('api:invoke', {
    method: 'POST',
    url: `${urls.apiUrl}verify-account`,
    headers: {
      'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
      'X-Device-ID': deviceId,
    },
    params: {
      include: 'patient',
      force,
    },
    data: {
      email,
      phone,
    },
  });

  if (result.data) {
    return result;
  }

  throw result;
};

export const verifyDateOfBirth = async (
  dateOfBirth: string,
  osType: string,
  osVersion: string,
  app: App,
  appVersion: string,
  deviceId: string
) => {
  const result = await mediator.request<ApiResponse<{ code: number }>>('api:invoke', {
    method: 'POST',
    url: `${urls.apiUrl}verify-dob`,
    headers: {
      'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
      'X-Device-ID': deviceId,
    },
    params: {
      include: 'patient',
    },
    data: {
      dateOfBirth,
    },
  });

  if (result.data) {
    return result;
  }

  throw result;
};

export const setupPassword = async (
  newPassword: string,
  osType: string,
  osVersion: string,
  app: App,
  appVersion: string,
  deviceId: string
) => {
  const result = await mediator.request<ApiResponse<{ code: number; error: unknown }>>(
    'api:invoke',
    {
      method: 'POST',
      url: `${urls.apiUrl}setup-password`,
      headers: {
        'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
        'X-Device-ID': deviceId,
      },
      params: {
        include: 'patient',
      },
      data: {
        newPassword,
      },
    }
  );

  if (result.data) {
    return result;
  }

  throw result;
};

export const forgotPassword = async (
  phone: string,
  osType: string,
  osVersion: string,
  app: App,
  appVersion: string,
  deviceId: string
) => {
  const result = await mediator.request<ApiResponse>('api:invoke', {
    method: 'POST',
    url: `${urls.apiUrl}forgot-password`,
    headers: {
      'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
      'X-Device-ID': deviceId,
    },
    params: {
      include: 'patient',
    },
    data: {
      phone,
    },
  });

  if (result.data) {
    return result;
  }

  throw result;
};

export const verifyPhoneCode = async (
  code: string,
  phone: string,
  osType: string,
  osVersion: string,
  app: App,
  appVersion: string,
  deviceId: string
) => {
  const result = await mediator.request<ApiResponse<{ code: number }>>('api:invoke', {
    method: 'POST',
    url: `${urls.apiUrl}verify-phone`,
    headers: {
      'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
      'X-Device-ID': deviceId,
    },
    data: {
      phone,
      code,
    },
  });

  if (result.data) {
    return result;
  }

  throw result;
};
